export const BULK_DELETE_MENU_TYPE_NOT_SYNC_FOODY	= 0;
export const BULK_DELETE_MENU_TYPE_ALL = 1;

export const SHOP_STATUS_MASK_ACTIVE = 0;
export const SHOP_STATUS_MASK_SUBSCRIPTION_EXPIRED = 1;
export const SHOP_STATUS_MASK_BLOCKED = 2;
export const SHOP_STATUS_MASK_ARCHIVED = 4;
export const MAX_SHOP_STATUS = SHOP_STATUS_MASK_ARCHIVED;

export const SHOP_STATUS_NAME = {
  [SHOP_STATUS_MASK_ACTIVE]: 'Active',
  [SHOP_STATUS_MASK_SUBSCRIPTION_EXPIRED]: 'Expired',
  [SHOP_STATUS_MASK_BLOCKED]: 'Blocked',
  [SHOP_STATUS_MASK_ARCHIVED]: 'Archived',
};

function padDate(n) {
  return String("00" + n).slice(-2);
}
const generateDate = (date) => {
  return `${date.getFullYear()}-${padDate(date.getMonth() + 1)}-${padDate(date.getDate())}`;
}

export const generateRentalStatus = (record) => {
  const { rental_status } = record;
  if (rental_status) {
    return rental_status;
  }

  const { rental_info } = record;
  if (!rental_info) {
    return 'No Renting';
  }

  const current_time = (new Date()).getTime();
  if (rental_info.expiry_time < current_time) {
    return `Renting (Overdue: ${generateDate(new Date(rental_info.expiry_time))})`;
  } else {
    return `Renting (Expiry Date: ${generateDate(new Date(rental_info.expiry_time))})`;
  }
};

export const ExtendInputOptions = {
  fullWidth: true,
};

export const DisabledExtendSelectOptions = {
  ...ExtendInputOptions,
  disabled: true,
  inputStyle: {
    color: 'black'
  },
  labelStyle: {
    color: 'black'
  },
};

export const AppTypeChoices = [
  { id: 1, name: 'Ocha POS' },
  { id: 2, name: 'Ocha Manager' },
  { id: 3, name: 'Ocha Staff' },
];

export const getDateBefore = (range) => {
  let date = new Date();
  date.setDate(date.getDate() - range);
  return date;
};


// WEBPACK FOOTER //
// ./src/routes/shop/utils.js